import { HttpClientT, IRequestOpts } from '@invent/shared-types';
import type { IDashboardWidget } from '@/src/domains/widgets/types';
import { IDashboardFetchResponse } from './events';
import { isNil } from 'ramda';

export type SaveDashboardApiT = {
  meta: IDashboard['meta'];
  widgets: IDashboardWidget[];
};

export function saveDashboard(
  dashboard: SaveDashboardApiT,
  httpClient: HttpClientT<{ result: IServerDashboard | IServerDashboard[]; url?: string }>
): Promise<{ result: IServerDashboard | IServerDashboard[]; url?: string }> {
  const searchParams = new URLSearchParams(document.location.search);
  const board_ctx = !isNil(searchParams.get('x-db-ctx'))
    ? Number(searchParams.get('x-db-ctx'))
    : undefined;

  return httpClient(
    `${window.CUSTOMIZATION_BE}/dashboards`,
    Object.assign(
      {
        method: 'post',
        traceId: 'core-save-dashboard-1',
        params: { body: JSON.stringify(dashboard) }
      } satisfies IRequestOpts,
      isNil(board_ctx)
        ? {}
        : {
            headers: {
              'Content-Type': 'application/json',
              'x-db-ctx': String(board_ctx)
            }
          }
    )
  );
}

export function getDashboardPreviewList(
  httpClient: HttpClientT<IDashboardShort[]>
): Promise<IDashboardShort[]> {
  return httpClient(`${window.CUSTOMIZATION_BE}/dashboards`, {
    traceId: 'core-get-dashboards-1'
  });
}

interface IDashboardMeta {
  dashboardId: string | null;
  httpClient: HttpClientT<IDashboardFetchResponse>;
  signal?: AbortSignal;
  fromComposer?: boolean;
  board_ctx?: number;
}

export function loadDashboard({
  dashboardId,
  httpClient,
  signal,
  fromComposer,
  board_ctx
}: IDashboardMeta): Promise<IDashboardFetchResponse> {
  return httpClient(
    `${window.CUSTOMIZATION_BE}/dashboards/${dashboardId}?composer=${Boolean(fromComposer)}`,
    Object.assign(
      {
        signal,
        traceId: 'core-get-dashboard-1'
      },
      isNil(board_ctx)
        ? {}
        : {
            headers: {
              'x-db-ctx': String(board_ctx)
            }
          }
    )
  );
}
